module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.8292/img/platinum-tier-icon-bordered.svg"